import React from 'react'
import PropTypes from 'prop-types'

const ModalFooter = ({
  children,
  ...props
}) => {
  return (
    <div className='modal-footer'
      {...props}
    >
      {children}
    </div>
  )
}

ModalFooter.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node]
  )
}

export default ModalFooter



// WEBPACK FOOTER //
// ./app/components/Modal/ModalFooter.jsx